import PropTypes from 'prop-types';
import YesNoInput from '@components/input/yes-no.input.jsx';
import { useEffect, useRef, useState } from 'preact/hooks';

export default function YesNoButtonInput({
  label,
  name,
  currentValue,
  onChange,
  hidden,
  mode = 'toggle',
  disabled = false,
  className = '',
}) {
  const [value, setValue] = useState(currentValue);
  const inputRef = useRef(null);
  const handleOnChange = (e) => {
    onChange(e);
    setValue(e.target.value);
  }

  const handleOnClick = (e) => {
    e.preventDefault()
    setValue(value => value === 'yes' ? 'no' : 'yes');
    onChange({ target: { value: value === 'yes' ? 'no' : 'yes', name } });
  }

  useEffect(() => {
    setValue(currentValue)
  }, [currentValue]);


  return (
    <div className={`${hidden ? `hidden ${className}` : className}`}>
     <button onClick={handleOnClick}  className={`btn w-full  ${value === 'yes' ? 'btn-neutral' : 'border-secondary'}`} disabled={disabled}>
       <YesNoInput ref={inputRef} labelTextClassName={value === 'yes' ? 'text-white' : ''} mode={mode} currentValue={value} onChange={handleOnChange} disabled={disabled} hidden={hidden} name={name} label={label} />
     </button>
    </div>
  );
}

YesNoButtonInput.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  currentValue: PropTypes.string,
  onChange: PropTypes.func,
  hidden: PropTypes.bool,
  mode: PropTypes.oneOf(['checkbox', 'toggle']),
  disabled: PropTypes.bool,
  className: PropTypes.string,
};
